// Local HTTP frontend -> HTTPS backend requests use a same-origin dev proxy.
export function captchaApiUrl(value) {
  if (process.env.NODE_ENV === 'development') {
    const target = new URL(process.env.VUE_APP_LOCAL_API_ORIGIN || 'https://localhost:44320');
    const url = new URL(value, window.location.href);
    if (url.origin === target.origin) return '/__local-api' + url.pathname + url.search;
  }
  return value;
}
